import React from "react";
import { useShipping } from "@/context/ShippingContext";
import SmallTip from "@components/SmallTip/SmallTip";
import Button from "@components/Button/Button";
import { RedirectIcon } from "@/components/MenusIcons/MenusIcons";
import FaLaptop from "@assets/icons/material-laptop.png";
import FaBox from "@assets/icons/material-box.png";
import config from "../../config";
import { getVisibleShippingItems, getMappedStatus, SHIPPING_MESSAGES } from "../../utils/shippingUtils";
import { formatShipDate } from '@/utils/dateUtils';

const ShippingItem: React.FC = () => {
  const { shippingData, loading, error } = useShipping();

  if (loading) {
    return <div className="alert alert-info">Loading shipments…</div>;
  }

  if (error) {
    return <div className="alert alert-danger">Error: {error}</div>;
  }

  if (!shippingData || shippingData.length === 0) {
    return (
        <SmallTip title={SHIPPING_MESSAGES.TRACKING_UNAVAILABLE.title}>
          <p>{SHIPPING_MESSAGES.TRACKING_UNAVAILABLE.description}</p>
        </SmallTip>
    );
  }

  const visibleItems = getVisibleShippingItems(shippingData);

  if (!visibleItems || visibleItems.length === 0) {
    return (
        <SmallTip title={SHIPPING_MESSAGES.TRACKING_UNAVAILABLE.title}>
          <p>{SHIPPING_MESSAGES.TRACKING_UNAVAILABLE.description}</p>
        </SmallTip>
    );
  }

  return (
    <div className="shipping-wrapper">
      {visibleItems.map((item, index) => {
        const statusText =
          getMappedStatus(item.status)?.toLowerCase() === "shipped" && item.shipDate
            ? `Shipped on ${formatShipDate(item.shipDate)}`.trim()
            : getMappedStatus(item.status);

        const icon =
          item.itemTypeCode === "4" ? (
            <img src={FaLaptop} alt="Laptop" width={40} height={40} />
          ) : (
            <img src={FaBox} alt="Item" width={40} height={40} />
          );

        let description = "";
        if (["0", "1", "2"].includes(item.itemTypeCode)) {
          description = item.itemDescription
            ? `Course Materials: ${item.itemDescription}`
            : "Course Materials";
        } else if (item.itemTypeCode === "4") {
          description = item.itemDescription
            ? `Hardware: ${item.itemDescription}`
            : "Hardware";
        }

        const method = item.carrier?.toLowerCase() || "";
        let trackingCta = "";
        let trackingUrl = "";

        if (method.includes("ups") && item.trackingNumber) {
          trackingCta = "UPS";
          trackingUrl = `${config.TRACKING_LINKS.UPS}${item.trackingNumber}`;
        } else if (method.includes("usps") && item.trackingNumber) {
          trackingCta = "USPS";
          trackingUrl = `${config.TRACKING_LINKS.USPS}${item.trackingNumber}`;
        } else if (method.includes("fedex") && item.trackingNumber) {
          trackingCta = "FedEx";
          trackingUrl = `${config.TRACKING_LINKS.FedEx}${item.trackingNumber}`;
        }

        return (
          <div key={index} className="ship-item">
            <div className="ship-title">
                <h4>
                    ITEM {index + 1} OF {visibleItems.length}
                </h4>
            </div>
            <div className="ship-content">   
                <div className="ship-status">
                    <h3 className="h3">{statusText}</h3>
                    <div className="ship-details">
                        {icon}
                        <p className="body-l">{description}</p>
                    </div>
                </div>
                    {trackingCta && trackingUrl && (
                    <Button
                        label={`Track Package (${trackingCta})`}
                        size="lg"
                        variant="border"
                        color="primary"
                        width="fit-content"
                        icon={<RedirectIcon />}
                        iconPosition="after"
                        linkUrl={trackingUrl}
                        linkTarget="_blank"
                    />
                    )}
                </div>
            </div>
        );
      })}
    </div>
  );
};

export default ShippingItem;
